module.exports = __webpack_public_path__ + "img/6.8c02a4cf.png";